import { styled, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';

const ColoredTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#2468FF',
        color: 'white',
        fontSize: '12px',
        padding: '12px',
        maxWidth: '187px',
        fontWeight: 400,
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: '#2468FF',
    },
}));

function SITooltip(props: {
    title: string;
    placement?:
        | 'bottom-end'
        | 'bottom-start'
        | 'bottom'
        | 'left-end'
        | 'left-start'
        | 'left'
        | 'right-end'
        | 'right-start'
        | 'right'
        | 'top-end'
        | 'top-start'
        | 'top';
    children;
}) {
    return (
        <ColoredTooltip arrow title={props.title} placement={props.placement || 'bottom'}>
            {props.children}
        </ColoredTooltip>
    );
}

export default SITooltip;
